import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ConversionEventsIcon(props: IconProps) {
  return (
    <Icon width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8071" r="36" fill="white" />
      <rect
        x="53.21"
        y="48.7389"
        width="9.46832"
        height="33.6644"
        rx="4.73416"
        transform="rotate(90 53.21 48.7389)"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path d="M45.1814 44.4934L45.1814 30.4613" stroke="#191A1C" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M27.5718 44.4934L27.5718 30.4613" stroke="#191A1C" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M36.3768 39.3069L36.3768 21.1756" stroke="#191A1C" strokeWidth="1.2" strokeLinecap="round" />
      <path
        d="M42.4121 27.53C42.4121 28.2644 42.7039 28.9688 43.2232 29.4881C43.7425 30.0074 44.4468 30.2991 45.1812 30.2991C45.9156 30.2991 46.6199 30.0074 47.1392 29.4881C47.6585 28.9688 47.9503 28.2644 47.9503 27.53C47.9503 26.7956 47.6585 26.0913 47.1392 25.572C46.6199 25.0527 45.9156 24.761 45.1812 24.761C44.4468 24.761 43.7425 25.0527 43.2232 25.572C42.7039 26.0913 42.4121 26.7956 42.4121 27.53Z"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3411 27.5298C30.3411 28.2642 30.0493 28.9685 29.53 29.4878C29.0107 30.0071 28.3064 30.2989 27.572 30.2989C26.8376 30.2989 26.1333 30.0071 25.614 29.4878C25.0947 28.9685 24.803 28.2642 24.803 27.5298C24.803 26.7954 25.0947 26.0911 25.614 25.5718C26.1333 25.0525 26.8376 24.7607 27.572 24.7607C28.3064 24.7607 29.0107 25.0525 29.53 25.5718C30.0493 26.0911 30.3411 26.7954 30.3411 27.5298Z"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.2149 36.9246C52.2149 37.659 52.5067 38.3633 53.026 38.8826C53.5453 39.4019 54.2496 39.6936 54.984 39.6936C55.7184 39.6936 56.4227 39.4019 56.942 38.8826C57.4613 38.3633 57.753 37.659 57.753 36.9246C57.753 36.1902 57.4613 35.4859 56.942 34.9666C56.4227 34.4473 55.7184 34.1555 54.984 34.1555C54.2496 34.1555 53.5453 34.4473 53.026 34.9666C52.5067 35.4859 52.2149 36.1902 52.2149 36.9246Z"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5383 36.9246C20.5383 37.659 20.2465 38.3633 19.7272 38.8826C19.2079 39.4019 18.5036 39.6936 17.7692 39.6936C17.0348 39.6936 16.3305 39.4019 15.8112 38.8826C15.2919 38.3633 15.0002 37.659 15.0002 36.9246C15.0002 36.1902 15.2919 35.4859 15.8112 34.9666C16.3305 34.4473 17.0348 34.1555 17.7692 34.1555C18.5036 34.1555 19.2079 34.4473 19.7272 34.9666C20.2465 35.4859 20.5383 36.1902 20.5383 36.9246Z"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.609 17.5762C33.609 18.3106 33.9007 19.0149 34.42 19.5342C34.9393 20.0535 35.6436 20.3452 36.378 20.3452C37.1124 20.3452 37.8168 20.0535 38.3361 19.5342C38.8554 19.0149 39.1471 18.3106 39.1471 17.5762C39.1471 16.8418 38.8554 16.1375 38.3361 15.6182C37.8168 15.0989 37.1124 14.8071 36.378 14.8071C35.6436 14.8071 34.9393 15.0989 34.42 15.6182C33.9007 16.1375 33.609 16.8418 33.609 17.5762Z"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.1814 44.4843V40.6258C45.1814 38.5811 46.839 36.9236 48.8836 36.9236L52.7943 36.9236"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M27.5718 40.2812V40.2812C27.5718 38.4269 26.0685 36.9236 24.2141 36.9236L19.9589 36.9236"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path d="M31.5172 53.4727H41.2359" stroke="#191A1C" strokeWidth="1.2" strokeLinecap="round" />
    </Icon>
  );
}
